import { EndpointSetting } from "@/constants/app/type";
import { setCookie, setLocalStorage } from "@/utils/app/storage";
import { UserState } from "../type";

export const callbackLogin: EndpointSetting["caller"] = (
  state: UserState,
  action: any,
  endpointName: any
) => {
  try {
    // Check if the action payload has all required fields
    if (!action?.payload) {
      state.login.loading = false;
      state.login.error = "Invalid response data";
      state.login.success = false;
      return;
    }

    const { customer, accessToken } = action.payload;

    // Update state
    state.login.loading = false;
    state.login.error = null;
    state.login.success = true;

    // Set user profile data
    state.profile.data = customer;

    // Set authentication state
    state.isAuthen = !!accessToken;

    // Save to localStorage and cookies
    if (customer) {
      setLocalStorage("user", customer);
    }

    if (accessToken) {
      setCookie("token", accessToken);
    }
  } catch (error) {
    // Handle any errors that occur during the process
    console.error("Error in callbackLogin:", error);

    // Update state to reflect the error
    state.login.loading = false;
    state.login.error =
      error instanceof Error ? error.message : "Unknown error";
    state.login.success = false;
  }
};
